import React, { useState } from 'react'
import {
  ATLDivider,
  ATLGenericListItem,
  FontWeightEnum,
  GenericListItemLeftElementEnum,
  GenericListItemRightElementEnum,
} from '@appsimples/atlantica-react-native'
import styled from 'styled-components/native'
import { atlTheme } from '../../atlTheme'
import { icons } from '../../constants/searchAssets'
import { IconTwoText } from '../../screens/FinanceScreens/components/IconTwoText'
import { ifMoneyInt } from '../../utils/formatters'
import { Colors } from '../../constants/colors'
import { getInstallmentDateAndTypeLabel } from '../../screens/FinanceScreens/constants'

interface AccordionProps {
  title: string
  installments?: any
}

const AccordionContainer = styled.View`
  background-color: ${atlTheme.ColorSurface};
  border-radius: ${atlTheme.BorderRadiusCard}px;
`

const TitleContainer = styled.View`
  margin-vertical: -${atlTheme.SpacingBase}px;
`

const ItemContainer = styled.View`
  margin-left: -${atlTheme.SpacingAtomic}px;
  margin-top: -${atlTheme.SpacingBase}px;
`

export const Accordion: React.FunctionComponent<AccordionProps> = props => {
  const [isCollapsed, setIsCollapsed] = useState(true)

  const toggleIsCollapsed = () => {
    setIsCollapsed(!isCollapsed)
  }

  return (
    <AccordionContainer>
      <TitleContainer>
        <ATLGenericListItem
          verticalMargin={0.1}
          dividerBaseProps={{ thickness: 0 }}
          rightElement={GenericListItemRightElementEnum.icon}
          rightIcon={isCollapsed ? icons.arrowDown : icons.arrowUp}
          leftIcon={icons.checkCircleIcon}
          leftElement={GenericListItemLeftElementEnum.icon}
          leftIconBaseProps={{ tintColor: Colors.successGreen }}
          title={props.title}
          titleLabelBaseProps={{
            textColor: atlTheme.ColorHighContrast,
            fontFamily: atlTheme.FontFamilyBrand,
            multilineLimit: 10,
            fontSize: atlTheme.FontSizeBody,
            fontWeight: FontWeightEnum.medium,
          }}
          onPressItem={toggleIsCollapsed}
        />
      </TitleContainer>
      {!isCollapsed &&
        props.installments?.map((installmentPaid, index) => {
          const date = new Date(installmentPaid.dueDate)
          return installmentPaid.receipts?.map(receipt => {
            const isNotFirst = index !== 0
            return (
              <ItemContainer key={index}>
                {isNotFirst && <ATLDivider dividerBaseProps={{ color: atlTheme.ColorBackground }} />}
                <IconTwoText
                  firstTextVertical={getInstallmentDateAndTypeLabel(date, installmentPaid?.conditionDescription)}
                  secondTextVertical={`${ifMoneyInt(receipt.receiptValue)}`}
                  twoText
                />
              </ItemContainer>
            )
          })
        })}
    </AccordionContainer>
  )
}
